import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10 px-5 md:px-20">
      {/* Newsletter Section */}
      <div className="border-b border-gray-700 pb-8 mb-8 text-center">
        <h2 className="text-2xl font-semibold text-white mb-2">
          Sign up to get updates on new products and more!
        </h2>
        <p className="text-gray-400 mb-4">
          Join to get the latest on sales, new arrivals and more...
        </p>
        <div className="flex justify-center gap-2">
          <input
            type="email"
            placeholder="Your Email Address..."
            className="px-4 py-2 rounded-l-md w-64 bg-gray-800 text-white focus:outline-none"
          />
          <button className="bg-[#f97316] hover:bg-[#ea580c] px-4 py-2 rounded-r-md font-semibold text-white">
            Subscribe
          </button>
        </div>
      </div>

      {/* Footer Links */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        {/* Categories */}
        <div>
          <h3 className="text-white font-bold mb-3">Categories</h3>
          <ul className="space-y-2">
            <li>Grinders</li>
            <li>Rolling Papers & Cones</li>
            <li>Glass Bongs</li>
            <li>Pipes & Chillums</li>
            <li>Storage & Lighters</li>
            <li>Vape Accessories</li>
          </ul>
        </div>

        {/* Navigate */}
        <div>
          <h3 className="text-white font-bold mb-3">Navigate</h3>
          <ul className="space-y-2">
            <li>Terms & Conditions</li>
            <li>Privacy Policy</li>
            <li>Shipping & Return Policy</li>
          </ul>
        </div>

        {/* Other */}
        <div>
          <h3 className="text-white font-bold mb-3">Other</h3>
          <ul className="space-y-2">
            <li>Home</li>
            <li>Contact Us</li>
            <li>About Us</li>
            <li>Blogs</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-white font-bold mb-3">
            SMOKY SHOP WHOLESALE WAREHOUSE
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-2">
              <MapPin size={18} /> 10549 King William Dr, Dallas, TX 75220
            </li>
            <li className="flex items-center gap-2">
              <Phone size={18} /> (833) 735-2757
            </li>
            <li className="flex items-center gap-2">
              <Mail size={18} /> SmokyShop@gmail.com
            </li>
          </ul>
          <p className="text-gray-400 text-sm mt-4">
            <strong>Service Hours:</strong><br />
            Mon–Fri: 9AM - 6PM<br />
            Saturday: 10AM - 5PM<br />
            Sunday: Closed
          </p>
        </div>
      </div>

      {/* Bottom note */}
      <div className="text-center border-t border-gray-800 mt-10 pt-6 text-gray-500 text-sm">
        © 2025 SMOKY SHOP WHOLESALE WAREHOUSE. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
